// extracted by mini-css-extract-plugin
module.exports = {"container":"SuccessErrorMessage_container__3uoMa","containerSmall":"SuccessErrorMessage_containerSmall__1Yvsn"};